import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter
} from '@/components/ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue
} from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

/**
 * Bulk status update modal for shipments
 * Used by ExportsDashboard and ImportsDashboard
 */
export default function BulkStatusModal({
  open,
  onOpenChange,
  selectedCount,
  statuses,
  selectedStatus,
  onStatusChange,
  onSubmit,
  processing,
  entityType = 'Exports' // 'Exports' or 'Imports'
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800" data-testid="bulk-status-modal">
        <DialogHeader>
          <DialogTitle className="text-white">Update {selectedCount} {entityType}</DialogTitle>
          <DialogDescription className="text-slate-400">
            Change status for all selected {entityType.toLowerCase()}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <Select value={selectedStatus} onValueChange={onStatusChange}>
            <SelectTrigger className="bg-slate-950 border-slate-700 text-white">
              <SelectValue placeholder="Select new status" />
            </SelectTrigger>
            <SelectContent className="bg-slate-900 border-slate-700">
              {statuses.map(status => (
                <SelectItem key={status} value={status}>{status}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700">
            Cancel
          </Button>
          <Button 
            onClick={onSubmit} 
            disabled={!selectedStatus || processing} 
            className="bg-amber-600 hover:bg-amber-500"
            data-testid="bulk-status-submit"
          >
            {processing && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
            Update Status
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
